import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=62ebf94a&scoped=true&"
import script from "./Todos.vue?vue&type=script&lang=js&"
export * from "./Todos.vue?vue&type=script&lang=js&"
import style0 from "./Todos.vue?vue&type=style&index=0&id=62ebf94a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ebf94a",
  null
  
)

export default component.exports